export enum GamesRecordType {
    home = 'home',
    road = 'road',
    Last10Games = 'Last10Games',
}
